import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DfxParams } from './models/dfx-params.model';
import { SettingsService } from './services/settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  logo: Blob;

  formFiles = this.formBuilder.group({
    template: [''],
    logo: ['']
  });

  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private settingsService: SettingsService,
    private snack: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.loadLogo();

    this.settingsService.getDfxParams()
      .subscribe(params => this.createForm(params));
  }


  save() {
    this.saveLogo();
    this.saveTemplate();
    this.saveParams();
  }

  removeLogo() {
    this.settingsService.deleteLogo()
      .subscribe(logo => this.logo = null);
  }

  private loadLogo() {
    this.settingsService.getLogo().subscribe(logo => this.logo = logo);
  }

  private saveLogo() {
    const logoInput = this.formFiles.get('logo');
    const logo = logoInput.value;

    if (logo && logo.files.length > 0) {
      this.settingsService.setLogo(logo.files[0])
        .subscribe(() => this.loadLogo());
    }
  }

  private saveTemplate() {
    const input = this.formFiles.get('template');
    const value = input.value;

    if (value && value.files.length > 0) {
      this.settingsService.setDfxTemplate(value.files[0]).subscribe();
    }
  }

  private createForm(params: DfxParams) {
    this.form = this.formBuilder.group({
      dxf_params_responsible: [params.dxf_params_responsible, Validators.required],
      dxf_technical_responsible: [params.dxf_technical_responsible, Validators.required],
      dxf_approver: [params.dxf_approver, Validators.required],
    });
  }

  private saveParams() {
    this.form.disable();
    this.settingsService.setDfxParams(this.form.value)
      .subscribe(params => {
        this.snack.open($localize`Updated template parameters`, $localize`CLOSE`, { duration: 2000 });
        this.form.enable();
      });
  }

}
